import pino from "pino"
import { consoleLogWriterConfig, getOtelTraceContext, logLevelLabels, logLevels } from "./logger-utils"
import { emitBrowserOtelLog } from "../telemetry/otel-logs"

// Min log level
const minLevelLabel = logLevelLabels.error

export default function ProdLogger() {
  return pino({
    level: minLevelLabel,
    customLevels: logLevels,
    useOnlyCustomLevels: true,
    enabled: true, // can be set to disable the complete logs
    mixin: getOtelTraceContext,
    browser: {
      asObject: true,
      disabled: false,
      serialize: true,
      formatters: {
        level: (label, number) => {
          return { level: number, label }
        },
      },
      write: consoleLogWriterConfig(minLevelLabel),
      transmit: {
        level: minLevelLabel,
        send: (level, logEvent) => {
          const bindings = logEvent.bindings?.reduce((acc, b) => Object.assign(acc, b), {}) ?? {}
          const extraAttrs = { 'log.source': 'pino' }
          if (bindings.module) extraAttrs['log.module'] = bindings.module
          emitBrowserOtelLog(level, logEvent.messages, extraAttrs)
        },
      },
    },
  })
}
